import React, { useState } from "react";
import PropTypes from "prop-types";
import { gql } from "@apollo/client";
import { Mutation } from "@apollo/client/react/components";
import CmpAgGrid from "../../lib/AgGrid/CmpAgGrid";
import { contractIdFromPath } from "../../lib/Util/url";
import Modal from "../../lib/Util/Modal";

const HOAddUsersModalBtn = ({ params }) => {
  const [disabled, setDisabled] = useState(false);

  const onClick = update => {
    setDisabled(true);
    update({
      variables: {
        id: params.data.id,
        contractId: contractIdFromPath(),
        addAsHeadOffice: true
      }
    });
  };

  const onError = ({ graphQLErrors, networkError }) => {
    console.log("onError occurred");
    console.log(graphQLErrors);
    console.log(networkError);
    setDisabled(false);
  };

  const onCompleted = data => {
    params.api.applyServerSideTransaction({ remove: [params.data] });
  };

  return (
    <Mutation
      mutation={TOGGLE_CONTRACT}
      onError={onError}
      onCompleted={onCompleted}
    >
      {update => (
        <button
          onClick={() => onClick(update)}
          className="button button--small"
          disabled={disabled}
        >
          Add to Contract
        </button>
      )}
    </Mutation>
  );
};

HOAddUsersModalBtn.propTypes = {
  params: PropTypes.object.isRequired
};

const TOGGLE_CONTRACT = gql`
  mutation toggleUserContract($id: ID!, $contractId: ID!, $addAsHeadOffice: Boolean) {
    toggleUserContract(id: $id, contractId: $contractId, addAsHeadOffice: $addAsHeadOffice) {
      onContract
    }
  }
`;

const AddUsersModal = ({ onClose, currentUser }) => {
  const defaultColumnDefs = [
    { headerName: "First Name", field: "firstName", filter: "agTextColumnFilter" },
    { headerName: "Last Name", field: "lastName", filter: "agTextColumnFilter", sort: "asc" },
    { headerName: "Email", field: "email", filter: "agTextColumnFilter" },
    { headerName: "Status", field: "status", filter: "agSetColumnFilter", filterParams: { values: ["Active", "Inactive"] } },
    { headerName: "Action", field: "action", sortable: false, filter: false, cellRenderer: "addToContractRenderer" }
  ];

  const frameworkComponents = {
    addToContractRenderer: row => {
      return <HOAddUsersModalBtn params={row} />;
    }
  };

  const contractAddableHoUsersQuery = () => {
    const id = contractIdFromPath();
    return gql`
      query ContractAddableHoUsers($agGridParams: RequestParamInput!) {
        contractAddableHoUsers(agGridParams: $agGridParams, contractId:${id}) {
          id
          firstName
          lastName
          email
          status
        }
      }
    `;
  };

  return (
    <Modal
      show={true}
      onClose={onClose}
      header="Add Head Office Users"
      className="add-ho-users-modal"
      renderFooter={() => (
        <button className="button aidacare" onClick={onClose}>
          Done
        </button>
      )}
    >
      <div className="alert margin-bottom-tiny" role="alert">
        <p>
          <strong>Note:</strong> Only users with "@aidacare.com.au" email addresses and a "User to Enter" set can be added to the contract.
        </p>
      </div>
      <CmpAgGrid
        userId={currentUser.id}
        defaultColumnDefs={defaultColumnDefs}
        gqlQuery={contractAddableHoUsersQuery}
        responseDataKey="contractAddableHoUsers"
        frameworkComponents={frameworkComponents}
        preserveSelection={false}
        getRowId={params => String(params.data.id)}
      />
    </Modal>
  );
};

AddUsersModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired
};

export default AddUsersModal;
